export default "__VITE_ASSET__CeJD$3kC__"